<template>
  <div class="material-actions">
    <p class="material-actions-subtitle">
      {{ selectedMaterialName || "Material seleccionado" }}
    </p>
    <div class="material-actions-grid">
      <button
        class="action-card"
        :disabled="!selectedMaterialPdf"
        :title="selectedMaterialPdf ? 'Descargar PDF' : 'Este material no tiene PDF'"
        @click="downloadMaterial"
      >
        <span class="action-emoji">⬇️</span>
        <span class="action-title">Descargar el material</span>
        <span class="action-desc">Obtén el PDF listo para aplicar.</span>
      </button>

      <button class="action-card" @click="editMaterial">
        <span class="action-emoji">✏️</span>
        <span class="action-title">Editar y guardar</span>
        <span class="action-desc">
          Modifica el material y guárdalo como uno nuevo.
        </span>
      </button>

      <button class="action-card" @click="generateReport">
        <span class="action-emoji">📊</span>
        <span class="action-title">Generar informe</span>
        <span class="action-desc">
          Ingresa los resultados de una aplicación y genera el informe.
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaterialActions",
  props: {
    context: {
      type: Object,
      required: true,
    },
    canWork: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    selection() {
      const conv = this.$store.state.chatbot.conversation;
      return conv && conv.existing_materials_list
        ? conv.existing_materials_list
        : {};
    },
    selectedMaterialName() {
      return this.selection.selectedMaterialName || "";
    },
    selectedMaterialPdf() {
      return this.selection.selectedMaterialPdf || null;
    },
  },
  methods: {
    // Download stays on this question — no navigation.
    downloadMaterial() {
      const url = this.selectedMaterialPdf;
      if (!url) return;
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    editMaterial() {
      this.$emit("go-to-step", "existing_material_viewer");
    },
    generateReport() {
      this.$emit("go-to-step", "score_input");
    },
  },
};
</script>

<style scoped>
.material-actions {
  padding: 10px 0;
}
.material-actions-subtitle {
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}
.material-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}
.action-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 6px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  padding: 16px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s;
}
.action-card:hover:not(:disabled) {
  border-color: #ef4444;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.12);
}
.action-card:active:not(:disabled) {
  transform: translateY(1px);
}
.action-card:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.action-emoji {
  font-size: 22px;
}
.action-title {
  font-weight: 700;
  color: #111827;
}
.action-desc {
  font-size: 13px;
  color: #6b7280;
}
</style>
